<div class="flex flex-col h-screen bg-white overflow-hidden">
    <!-- Header -->
    <header class="flex-none p-6 z-20 bg-white relative">
        <img src="assets/FINTRAX_LOGO_POS.svg" alt="Fintrax" class="h-10" />
    </header>

    <!-- Main Content -->
    <main class="flex-grow flex items-center justify-center p-6 bg-slate-50/50">
        <div class="w-full max-w-md bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col">
            
            <h1 class="text-2xl font-bold text-slate-800 mb-8 text-center" i18n="@@login.login">Meld aan</h1>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col w-full">
                
                <!-- Silverfin Login Button -->
                <button
                    type="button"
                    class="button-silverfin w-full flex items-center justify-center gap-3 py-3 rounded-lg transition-all hover:opacity-90 active:scale-[0.98]"
                    [disabled]="busy"
                    (click)="silverfinLoginRedirect()"
                    (keypress)="silverfinLoginRedirect()"
                >
                    <img class="h-8 w-auto" src="/assets/icons/silverfin.png" />
                    <span class="font-medium text-white" i18n="@@login.loginSilverfin.icon">Meld aan met Silverfin</span>
                </button>

                <!-- Separator -->
                <div class="relative flex items-center py-8">
                    <div class="flex-grow border-t border-slate-200"></div>
                    <span class="mx-4 text-xs font-semibold text-slate-400 uppercase tracking-wider" i18n="@@choice.or">of</span>
                    <div class="flex-grow border-t border-slate-200"></div>
                </div>

                <!-- Email & Password -->
                <div class="flex flex-col gap-5 mb-8">
                    <div class="flex flex-col gap-2">
                        <label for="inputEmail" class="text-sm font-medium text-slate-700" i18n="@@email">E-mailadres</label>
                        <input 
                            id="inputEmail" 
                            type="email" 
                            formControlName="email" 
                            class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                            required 
                        />
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="inputPassword" class="text-sm font-medium text-slate-700" i18n="@@password">Wachtwoord</label>
                        <input 
                            id="inputPassword" 
                            type="password" 
                            formControlName="password" 
                            class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                            required 
                        />
                    </div>
                </div>

                <!-- Submit Button -->
                <button 
                    type="submit" 
                    class="button-primary w-full py-3 rounded-lg font-medium shadow-sm hover:shadow-md transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    [disabled]="!loginForm.valid || busy"
                >
                    @if (!busy) {
                        <span i18n="@@login.login">Meld aan</span>
                    } @else {
                        <fa-icon [icon]="loadingIcon" [animation]="'spin'"></fa-icon>
                        <span i18n="@@login.busyLoggingIn">Bezig met aanmelden…</span>
                    }
                </button>

                <!-- Links -->
                <div class="mt-8 flex flex-col items-center gap-3 text-sm">
                    <a routerLink="/register" class="font-bold text-blue-600 hover:text-blue-700 hover:underline" i18n="@@login.registerAccount">Registreer een account</a>
                    <div class="flex gap-4 text-slate-500">
                        <a routerLink="/reset-password" class="hover:text-slate-800 hover:underline" i18n="@@login.forgotPassword">Wachtwoord vergeten</a>
                        <span>•</span>
                        <a routerLink="/resend-email" class="hover:text-slate-800 hover:underline" i18n="@@login.resendVerificationEmail">Stuur verificatiemail opnieuw</a>
                    </div>
                </div>

            </form>
        </div>
    </main>
</div>
